import React from 'react';

import { withFirebase } from '../Firebase';

const SignOutButton = ({ firebase, buttonStyle }) => (
  <button type="button" onClick={firebase.doSignOut} style={buttonStyle}>
    Sign Out
  </button>
);

export default withFirebase(SignOutButton);
